// Vendor imports
const React = require('react')
const PropTypes = require('prop-types')
const classNames = require('classnames')
// Shared imports
const BemEntity = require('shared/bem')
// Client V2 common imports
const tag = require('client-v2/common/utils/hyperscript')

const bem = BemEntity('Modal')

class Modal extends React.PureComponent {

  renderBackdrop() {
    if (!this.props.hasBackdrop) {
      return null
    }
    let onBackdropClick
    if (this.props.dismissOnBackdropClick) {
      onBackdropClick = this.props.onDismiss
    }
    return tag('div', {
      className: bem.element('backdrop'),
      onClick: onBackdropClick
    })
  }

  renderContent() {
    return tag('div', {
      className: bem.element('content')
    },
      this.props.children
    )
  }

  renderCloseButton() {
    if (!this.props.onDismiss) {
      return null
    }
    return tag('button', {
      className: bem.element('close-button'),
      onClick: this.props.onDismiss
    })
  }

  render() {
    if (!this.props.children) {
      return null
    }
    /**
     * @type {React.ReactElement<any>}
     * This allows for the modal to be a `DropZone`
     */
    const wrapperElement = (
      this.props.wrapperElement ||
      tag('div')
    )
    return React.cloneElement(wrapperElement, {
      className: classNames(
        wrapperElement.props.className,
        this.props.className,
        bem.block()
      )
    },
      this.renderBackdrop(),
      this.renderContent(),
      this.renderCloseButton()
    )
  }

}

Modal.propTypes = {
  // Flags
  dismissOnBackdropClick: PropTypes.bool,
  hasBackdrop: PropTypes.bool,
  // Values
  children: PropTypes.node,
  className: PropTypes.string,
  wrapperElement: PropTypes.element,
  // Callbacks
  onDismiss: PropTypes.func
}

Modal.defaultProps = {
  dismissOnBackdropClick: true,
  hasBackdrop: true
}

module.exports = Modal
